import { NavLink } from 'react-router-dom';

import classes from './SiteNavigation.module.css';

function PatentMenu(props) {
  return (
    <>
      <nav>
        <ul>
          <li>
            <NavLink
              to="/"
              onClick={props.closeMenu}
              className={({ isActive }) =>
                isActive ? classes.active : undefined
              }
              end
            >
              Patent Proofread
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/"
              onClick={props.closeMenu}
              className={({ isActive }) =>
                isActive ? classes.active : undefined
              }
              end
            >
              Patent Searching
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/"
              onClick={props.closeMenu}
              className={({ isActive }) =>
                isActive ? classes.active : undefined
              }
              end
            >
              Patent Inv???
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/"
              onClick={props.closeMenu}
              className={({ isActive }) =>
                isActive ? classes.active : undefined
              }
              end
            >
              Patent Drafting
            </NavLink>
          </li>
        </ul>
      </nav>
    </>
  );
}

export default PatentMenu;
